import { ref } from 'vue'

// Module-scoped singleton, like useRouteTransition: only one page is mounted at
// the top of the screen at a time, so one source of truth is enough and any
// layout or view can read or write it without prop drilling.
const systemBarColor = ref(null)

/**
 * Colour override for the app's fixed system bar -- the strip that covers the
 * notch on native and that iOS Safari samples for its status bar.
 *
 * Routes declare a static `meta.systemBar.color`, which cannot know the colour
 * of the note a detail page is about to show. A page sets the override while it
 * is mounted and passes null on the way out; App.vue resolves the two through
 * resolveSystemBarColor.
 */
export function useSystemBarColor() {
  return {
    systemBarColor,
    setSystemBarColor: color => { systemBarColor.value = color || null },
  }
}
